import { Dialog, DialogContent, DialogActions } from '@mui/material'
import * as React from 'react';
import "../style/profile2027.css"
import { Link } from 'react-router-dom'
import Loader from "../../../common/loader/containers/loader_cont";
import Snackbar from "../../../common/snackbar/components/snackbar";
import jsPDF from 'jspdf';
import Logo from './logo.png';
import 'jspdf-autotable';

// ─────────────────────────────────────────────────────────────
// FIX 1: Field defined OUTSIDE Profile → inputs never lose focus
// ─────────────────────────────────────────────────────────────
const Field = ({ label, children, error, required: req }) => (
  <div className={`p27-field ${error ? 'p27-field--error' : ''}`}>
    <label className="p27-label">{label}{req && <span className="p27-req">*</span>}</label>
    {children}
    {error && <span className="p27-err-msg">{error}</span>}
  </div>
);

// ─────────────────────────────────────────────────────────────
// FIX 2: Image size limits — 100 KB min, 250 KB max
// ─────────────────────────────────────────────────────────────
const MIN_IMG_BYTES = 100 * 1024;
const MAX_IMG_BYTES = 250 * 1024;

function validateImageSize(file) {
  if (!file) return null;
  if (file.size < MIN_IMG_BYTES)
    return `"${file.name}" is too small (${(file.size / 1024).toFixed(0)} KB). Minimum is 100 KB.`;
  if (file.size > MAX_IMG_BYTES)
    return `"${file.name}" is too large (${(file.size / 1024).toFixed(0)} KB). Maximum is 250 KB.`;
  return null;
}

// ─────────────────────────────────────────────────────────────
// FIX 3: Toggleable error summary banner
// ─────────────────────────────────────────────────────────────
const ErrorBanner = ({ errors }) => {
  const [open, setOpen] = React.useState(true);
  const list = Object.values(errors).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className="p27-error-banner">
      <button className="p27-error-banner-toggle" onClick={() => setOpen(o => !o)}>
        <span>⚠ {list.length} error{list.length > 1 ? 's' : ''} found — tap to {open ? 'hide' : 'show'} details</span>
        <span className="p27-error-banner-arrow">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <ul className="p27-error-banner-list">
          {list.map((msg, i) => <li key={i}>• {msg}</li>)}
        </ul>
      )}
    </div>
  );
};

// const Logo = "https://pvmodisha.in/wp-content/uploads/2025/06/cropped-cropped-prayash_logo-512-300x300.webp";

const districtsData = {
  "Odisha":["Angul","Balangir","Balasore","Bargarh","Bhadrak","Boudh","Cuttack","Deogarh","Dhenkanal","Gajapati","Ganjam","Jagatsinghpur","Jajpur","Jharsuguda","Kalahandi","Kandhamal","Kendrapada","Kendujhar","Khordha","Koraput","Malkangiri","Mayurbhanj","Nabarangpur","Nayagarh","Nuapada","Puri","Rayagada","Sambalpur","Subarnapur","Sundargarh"],
  "Andhra Pradesh":["Anantapur","Chittoor","East Godavari","Guntur","Kadapa","Krishna","Kurnool","Nellore","Prakasam","Srikakulam","Visakhapatnam","Vizianagaram","West Godavari"],
  "Bihar":["Araria","Arwal","Aurangabad","Banka","Begusarai","Bhagalpur","Bhojpur","Buxar","Darbhanga","East Champaran","Gaya","Gopalganj","Jamui","Jehanabad","Kaimur","Katihar","Patna","Rohtas","Saharsa","Samastipur","Saran","Sitamarhi","Siwan","Vaishali","West Champaran"],
  "West Bengal":["Alipurduar","Bankura","Birbhum","Cooch Behar","Dakshin Dinajpur","Darjeeling","Hooghly","Howrah","Jalpaiguri","Jhargram","Kolkata","Malda","Murshidabad","Nadia","North 24 Parganas","Purulia","South 24 Parganas"],
  "Uttar Pradesh":["Agra","Aligarh","Allahabad","Bareilly","Ghaziabad","Gorakhpur","Kanpur Nagar","Lucknow","Mathura","Meerut","Noida","Varanasi"],
  "Jharkhand":["Bokaro","Chatra","Deoghar","Dhanbad","Dumka","East Singhbhum","Garhwa","Giridih","Godda","Gumla","Hazaribagh","Jamtara","Khunti","Koderma","Latehar","Lohardaga","Pakur","Palamu","Ramgarh","Ranchi","Sahebganj","Seraikela Kharsawan","Simdega","West Singhbhum"],
};
const getDistricts = (state) => districtsData[state] || ["Others"];

const STEPS = [
  { id: 0, label: 'Student Profile', icon: '👤' },
  { id: 1, label: 'Address',         icon: '📍' },
  { id: 2, label: 'Academics',       icon: '🎓' },
  { id: 3, label: 'Documents',       icon: '📄' },
];

export default function Profile(props) {
  const [value, setValue]                                 = React.useState(0);
  const [preview, SetPreview]                             = React.useState(false);
  const [openDialog, setOpenDialog]                       = React.useState(false);
  const [confirmed, setConfirmed]                         = React.useState(false);
  const [passportPhotoFile, setPassportPhotoFile]         = React.useState(null);
  const [aadharCardFile, setAadharCardFile]               = React.useState(null);
  const [tenthMarksheetFile, setTenthMarksheetFile]       = React.useState(null);
  const [errors, setErrors]                               = React.useState({});
  const [docErrors, setDocErrors]                         = React.useState({});
  const [years, setYears]                                 = React.useState([]);
  const [yeartwo, setYearstwo]                            = React.useState([]);
  const [passportChecked, setPassportChecked]             = React.useState(false);
  const [tenthMarksheetChecked, setTenthMarksheetChecked] = React.useState(false);
  const [disabilitiesChecked, setDisabilitiesChecked]     = React.useState(false);

  React.useEffect(() => {
    const currentYear = new Date().getFullYear();
    const arr = [];
    const startYear = Math.max(currentYear, 2027); // ensures 2027 & 2026 are always included
    for (let i = startYear; i >= startYear - 14; i--) arr.push(i.toString());
    setYears(arr);
    setYearstwo([...arr]);
    if (props.login && props.login.user_details && props.login.user_details._id) {
      props.Userdetails(props.login.user_details._id);
    }
  }, []);

  // ── FIX 4: Success dialog only opens when backend responds with success ──
  const prevSnackRef = React.useRef(false);
  const hasMounted = React.useRef(false); // ADD THIS

 React.useEffect(() => {
  if (!hasMounted.current) {        // ADD THIS
    hasMounted.current = true;      // ADD THIS
    prevSnackRef.current = !!props.snackbar?.response_received; // seed the ref
    return;                         // ADD THIS — skip on mount
  }

  const received = props.snackbar?.response_received;
  if (received && !prevSnackRef.current) {
    const msg = (props.snackbar?.message || '').toLowerCase();
    if (
      msg.includes('success') ||
      msg.includes('submitted') ||
      msg.includes('updated') ||
      msg.includes('saved')
    ) {
      setOpenDialog(true);
    }
  }
  prevSnackRef.current = !!received;
}, [props.snackbar?.response_received, props.snackbar?.message]);

  const handleBack = () => { setValue(prev => Math.max(prev - 1, 0)); setErrors({}); };

  // ── Document handlers with size validation ───────────────────
  const handlePassportPhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const err = validateImageSize(file);
    if (err) {
      setDocErrors(p => ({ ...p, passport: err }));
      setPassportPhotoFile(null);
      e.target.value = '';
    } else {
      setDocErrors(p => ({ ...p, passport: '' }));
      setPassportPhotoFile(file);
    }
  };

  const handleAadharCardChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type.startsWith('image/')) {
      const err = validateImageSize(file);
      if (err) {
        setDocErrors(p => ({ ...p, aadhar: err }));
        setAadharCardFile(null);
        e.target.value = '';
        return;
      }
    }
    setDocErrors(p => ({ ...p, aadhar: '' }));
    setAadharCardFile(file);
  };

  const handleTenthMarksheetChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const err = validateImageSize(file);
    if (err) {
      setDocErrors(p => ({ ...p, signature: err }));
      setTenthMarksheetFile(null);
      e.target.value = '';
    } else {
      setDocErrors(p => ({ ...p, signature: '' }));
      setTenthMarksheetFile(file);
    }
  };

  const handleSubmit = () => {
    if (!confirmed) return;
    props.addUploadAsset(
      props.login.admin_id, props.login.user_details.name,
      props.login.user_details.mobile, props.login.user_details.aadhar,
      props.login.user_details.dob, props.assets.gender, props.assets.cat_nam,
      props.assets.fname, props.assets.Mname, props.assets.disabilities,
      props.assets.wpno, props.assets.state, props.assets.dist, props.assets.block,
      props.assets.village, props.assets.pin, props.assets.school, props.assets.schoolboard,
      props.assets.schoolpass, props.assets.schoolfullmark, props.assets.schoolfullmarksec,
      props.assets.clg, props.assets.clgboard, props.assets.clgpass, props.assets.clgfullmark,
      props.assets.fullmarksecclg, props.assets.neet, props.assets.neetatm,
      props.assets.examcenter, passportPhotoFile, props.assets.user_all_data?.profile_pic,
      aadharCardFile, props.assets.user_all_data?.aadharcertif,
      tenthMarksheetFile, props.assets.user_all_data?.tenthmarksheet,
    );
  };

  // ══════════════════════════════════════════════════════════════
  // PROFESSIONAL GOVERNMENT-STYLE ACKNOWLEDGEMENT PDF
  // Colors: Black (#000000), White (#FFFFFF), Green (#9dde59)
  // ══════════════════════════════════════════════════════════════
  const generatePDF2 = async () => {
const doc = new jsPDF({
  orientation: 'portrait',
  unit: 'mm',
  format: 'a4',
  compress: true,
});    const PW = 210;
    const PH = 297;
    const name = props.login?.user_details?.name || '';

    // ── Unique acknowledgement number & timestamp ──
    const ackNo = 'PRC/NEET27/' + Date.now().toString().slice(-10);
    const now   = new Date();
    const submitDate =
      now.toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) +
      '  |  ' +
      now.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });

    // ── Colour palette: Black / White / #9dde59 green ──
    const BLACK      = [0,   0,   0  ];
    const WHITE      = [255, 255, 255];
    const GREEN      = [157, 222,  89]; // #9dde59
    const DARK_GREEN = [100, 160,  40]; // darker shade for text on green bg
    const LIGHT_GREY = [245, 245, 245];
    const MID_GREY   = [200, 200, 200];
    const TEXT_GREY  = [80,  80,  80 ];
    const TEXT_DARK  = [20,  20,  20 ];
    const SUCCESS    = [60,  160,  20];

    // ─────────────────────────────────────────────
    // BORDER
    // ─────────────────────────────────────────────
    const drawBorders = () => {
      // Outer black border
      doc.setDrawColor(...BLACK);
      doc.setLineWidth(3);
      doc.rect(8, 8, PW - 16, PH - 16);
      // Inner green accent border
      doc.setDrawColor(...GREEN);
      doc.setLineWidth(1);
      doc.rect(11, 11, PW - 22, PH - 22);
    };

    // ─────────────────────────────────────────────
    // HEADER
    // ─────────────────────────────────────────────
    const drawHeader = async () => {
      // Black header band
      doc.setFillColor(...WHITE);
      doc.rect(11, 11, PW - 22, 36, 'F');

      // Green accent stripe under header
      doc.setFillColor(...GREEN);
      doc.rect(11, 47, PW - 22, 1.5, 'F');

      // Logo — try imported Logo first, then fetch from URL
      let logoAdded = false;

      // Try the imported head.png
      try {
        doc.addImage(Logo, 'PNG', 13, 13, 30, 30);
        logoAdded = true;
      } catch (_) { /* ignore */ }

      // Fallback: fetch from remote URL
      if (!logoAdded) {
        try {
          const res = await fetch(Logo);
          const blob = await res.blob();
          const b64 = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
          const ext = Logo.toLowerCase().includes('.webp') ? 'WEBP' : 'PNG';
          doc.addImage(b64, ext, 13, 13, 30, 30);
          logoAdded = true;
        } catch (_) { /* ignore */ }
      }

      // Fallback circle placeholder if both failed
      if (!logoAdded) {
        doc.setFillColor(...GREEN);
        doc.setDrawColor(...GREEN);
        doc.circle(28, 29, 11, 'FD');
        doc.setTextColor(...BLACK);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(5.5);
        doc.text('PRAYASH', 28, 27, { align: 'center' });
        doc.text('CLASSES', 28, 31, { align: 'center' });
      }

      // Organisation name
      doc.setTextColor(...BLACK);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(15);
      doc.text('NEET 2027 ADMISSION ', 48, 24);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(...GREEN);
      doc.text('A Premier Institution for NEET Preparation  ', 48, 31);

      // Thin white divider line inside header
     

      // Contact line
      doc.setTextColor(180, 180, 180);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      // doc.text('Jajpur, Odisha, India  |  Updates via WhatsApp', 48, 39);

      // Sub-title ribbon (green)
      doc.setFillColor(...GREEN);
      doc.rect(11, 48.5, PW - 22, 8, 'F');
      doc.setTextColor(...BLACK);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9.5);
      doc.text('APPLICATION ACKNOWLEDGEMENT', PW / 2, 54, { align: 'center' });

      // Candidate photo — top right
      // Candidate photo — top right
try {
  const imageUrl = props.assets?.user_all_data?.profile_pic
    || (passportPhotoFile ? URL.createObjectURL(passportPhotoFile) : null);
  if (imageUrl) {
    let imgData;
    if (passportPhotoFile && imageUrl.startsWith('blob:')) {
      // local file not yet uploaded — read directly
      imgData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(passportPhotoFile);
      });
    } else {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      imgData = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    }
    doc.setDrawColor(...GREEN);
    doc.setLineWidth(1.2);
    doc.rect(PW - 45, 13, 30, 34);
    doc.addImage(imgData, 'JPEG', PW - 45, 13, 30, 34);
  }
} catch (_) {
  // Photo placeholder
  doc.setFillColor(30, 30, 30);
  doc.setDrawColor(...GREEN);
  doc.setLineWidth(1);
  doc.rect(PW - 45, 13, 30, 34, 'FD');
  doc.setTextColor(180, 180, 180);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(6.5);
  doc.text('Candidate', PW - 30, 27, { align: 'center' });
  doc.text('Photo', PW - 30, 32, { align: 'center' });
}
    };

    // ─────────────────────────────────────────────
    // FOOTER
    // ─────────────────────────────────────────────
    const drawFooter = () => {
      doc.setFillColor(...BLACK);
      doc.rect(11, PH - 22, PW - 22, 11, 'F');

      doc.setTextColor(...GREEN);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7);
      doc.text('This is a computer-generated acknowledgement. No signature is required.', PW / 2, PH - 15, { align: 'center' });

      doc.setTextColor(...WHITE);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6.5);
      // doc.text('PRAYASH EDUCATION, Jajpur, Odisha  |  pvmodisha.in  |  All updates via WhatsApp', PW / 2, PH - 11, { align: 'center' });
    };

    // ─────────────────────────────────────────────
    // ACK BOX
    // ─────────────────────────────────────────────
    const drawAckBox = (startY) => {
      const bw = (PW - 22) / 3;
      const labels = ['Acknowledgement No.', 'Date & Time', 'Status'];
      const values = [ackNo, submitDate, 'RECEIVED'];
      const valColors = [TEXT_DARK, TEXT_DARK, SUCCESS];

      // Box background
      doc.setFillColor(...LIGHT_GREY);
      doc.setDrawColor(...MID_GREY);
      doc.setLineWidth(0.4);
      doc.rect(11, startY, PW - 22, 15, 'FD');

      // Dividers
      doc.line(11 + bw,     startY, 11 + bw,     startY + 15);
      doc.line(11 + bw * 2, startY, 11 + bw * 2, startY + 15);
      doc.line(11, startY + 7, PW - 11, startY + 7);

      // Green top strip
      doc.setFillColor(...GREEN);
      doc.rect(11, startY, PW - 22, 1.5, 'F');

      labels.forEach((lbl, i) => {
        const cx = 11 + bw * i + bw / 2;
        doc.setTextColor(...TEXT_GREY);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(6.5);
        doc.text(lbl, cx, startY + 5.5, { align: 'center' });

        doc.setTextColor(...valColors[i]);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(i === 2 ? 10 : 8);
        const prefix = i === 2 ? '\u2714  ' : '';
        doc.text(prefix + values[i], cx, startY + 13, { align: 'center' });
      });

      return startY + 19;
    };

    // ─────────────────────────────────────────────
    // SECTION HEADER (Black bar with green left accent)
    // ─────────────────────────────────────────────
    const drawSectionHeader = (label, y) => {
      // Black bar
      doc.setFillColor(...BLACK);
      doc.rect(11, y, PW - 22, 7.5, 'F');
      // Green left accent
      doc.setFillColor(...GREEN);
      doc.rect(11, y, 3.5, 7.5, 'F');

      doc.setTextColor(...WHITE);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(8.5);
      doc.text(label, 18, y + 5.2);
      return y + 9.5;
    };

    // ─────────────────────────────────────────────
    // TWO-COLUMN KEY-VALUE TABLE
    // ─────────────────────────────────────────────
    const drawTable = (rows, startY, labelW = 55, valW = 85) => {
      const rowH = 7;
      const tableW = labelW + valW;

      rows.forEach((row, i) => {
        const bg = i % 2 === 0 ? WHITE : LIGHT_GREY;
        doc.setFillColor(...bg);
        doc.rect(11, startY + i * rowH, tableW, rowH, 'F');

        doc.setDrawColor(...MID_GREY);
        doc.setLineWidth(0.25);
        doc.rect(11, startY + i * rowH, tableW, rowH);
        doc.line(11 + labelW, startY + i * rowH, 11 + labelW, startY + i * rowH + rowH);

        // Green dot accent on label
        doc.setFillColor(...GREEN);
        doc.circle(13.5, startY + i * rowH + 3.5, 0.8, 'F');

        doc.setTextColor(...TEXT_GREY);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7.5);
        doc.text(row[0], 16, startY + i * rowH + 4.8);

        doc.setTextColor(...TEXT_DARK);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.text(String(row[1] || '—'), 11 + labelW + 3, startY + i * rowH + 4.8);
      });

      return startY + rows.length * rowH + 3;
    };

    // ─────────────────────────────────────────────
    // MINI SECTION for side-by-side 10th/12th
    // ─────────────────────────────────────────────
    const drawMiniSection = (title, rows, x, y, colW) => {
      const halfLabel = 26;
      const rowH = 6.5;

      // Sub-header: black with green accent
      doc.setFillColor(...BLACK);
      doc.rect(x, y, colW, 7, 'F');
      doc.setFillColor(...GREEN);
      doc.rect(x, y, 3, 7, 'F');
      doc.setTextColor(...WHITE);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text(title, x + 6, y + 5);

      rows.forEach((row, i) => {
        const ry = y + 7 + i * rowH;
        const bg = i % 2 === 0 ? WHITE : LIGHT_GREY;
        doc.setFillColor(...bg);
        doc.rect(x, ry, colW, rowH, 'F');
        doc.setDrawColor(...MID_GREY);
        doc.setLineWidth(0.25);
        doc.rect(x, ry, colW, rowH);
        doc.line(x + halfLabel, ry, x + halfLabel, ry + rowH);

        doc.setTextColor(...TEXT_GREY);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7);
        doc.text(row[0], x + 2, ry + 4.3);

        doc.setTextColor(...TEXT_DARK);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text(String(row[1] || '—'), x + halfLabel + 2, ry + 4.3);
      });

      return y + 7 + rows.length * rowH + 2;
    };

    // ─────────────────────────────────────────────
    // DOCUMENT TABLE
    // ─────────────────────────────────────────────
    const drawDocTable = (startY) => {
      const cols = [75, 45, PW - 22 - 120];
      const headers = ['Document', 'Status', 'Remarks'];
      const docRows = [
        ['Passport Size Photo', '\u2714  Uploaded', 'Accepted'],
        ['Aadhaar Card',        '\u2714  Uploaded', 'Accepted'],
        ['Signature',           '\u2714  Uploaded', 'Accepted'],
      ];

      // Header row
      doc.setFillColor(...LIGHT_GREY);
      doc.setDrawColor(...MID_GREY);
      doc.setLineWidth(0.3);
      doc.rect(11, startY, PW - 22, 7, 'FD');

      // Green underline for header
      doc.setFillColor(...GREEN);
      doc.rect(11, startY + 6.5, PW - 22, 0.5, 'F');

      let cx = 11;
      headers.forEach((h, i) => {
        doc.setTextColor(...BLACK);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(7.5);
        doc.text(h, cx + 3, startY + 4.8);
        if (i < 2) {
          doc.setDrawColor(...MID_GREY);
          doc.line(cx + cols[i], startY, cx + cols[i], startY + 7);
        }
        cx += cols[i];
      });

      docRows.forEach((row, ri) => {
        const ry = startY + 7 + ri * 7;
        const bg = ri % 2 === 0 ? WHITE : LIGHT_GREY;
        doc.setFillColor(...bg);
        doc.rect(11, ry, PW - 22, 7, 'F');
        doc.setDrawColor(...MID_GREY);
        doc.rect(11, ry, PW - 22, 7);

        let dx = 11;
        row.forEach((cell, ci) => {
          if (ci === 1) {
            doc.setTextColor(...SUCCESS);
            doc.setFont('helvetica', 'bold');
          } else {
            doc.setTextColor(...TEXT_DARK);
            doc.setFont('helvetica', 'normal');
          }
          doc.setFontSize(8);
          doc.text(cell, dx + 3, ry + 4.8);
          if (ci < 2) {
            doc.setDrawColor(...MID_GREY);
            doc.line(dx + cols[ci], ry, dx + cols[ci], ry + 7);
          }
          dx += cols[ci];
        });
      });

      return startY + 7 + docRows.length * 7 + 3;
    };

    // ─────────────────────────────────────────────
    // DECLARATION BOX
    // ─────────────────────────────────────────────
    const drawDeclaration = (startY) => {
      const declText =
        'I hereby declare that all information furnished in this application is true, complete and correct to the best of my knowledge and belief. ' +
        'I understand that any false or misleading information may result in the cancellation of my admission.';

      // Light green tint bg with black border
      doc.setFillColor(240, 252, 220);
      doc.setDrawColor(...GREEN);
      doc.setLineWidth(0.8);
      doc.rect(11, startY, PW - 22, 16, 'FD');

      // Green left accent
      doc.setFillColor(...GREEN);
      doc.rect(11, startY, 3, 16, 'F');

      doc.setTextColor(...BLACK);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(7.5);
      doc.text('Declaration:', 17, startY + 5.5);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7.5);
      doc.setTextColor(...TEXT_DARK);
      const lines = doc.splitTextToSize(declText, PW - 32);
      doc.text(lines, 17, startY + 11);
      return startY + 20;
    };

    // ─────────────────────────────────────────────
    // SIGNATURE STRIP
    // ─────────────────────────────────────────────
   const drawSignatures = async (startY) => {
  // LEFT SIDE DATE
  doc.setTextColor(...TEXT_GREY);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);

  doc.text(
    `Date: ${now.toLocaleDateString('en-IN')}`,
    20,
    startY + 18
  );

  // SIGNATURE TITLE
  doc.setTextColor(...TEXT_DARK);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);

  doc.text(
    "Candidate's Signature",
    PW - 55,
    startY + 18
  );

  // GREEN SIGNATURE LINE
  doc.setDrawColor(...GREEN);
  doc.setLineWidth(0.8);

  doc.line(PW - 75, startY + 12, PW - 20, startY + 12);

  // SIGNATURE IMAGE
  try {
    const signUrl = props.assets?.user_all_data?.tenthmarksheet;

    if (signUrl) {
      const response = await fetch(signUrl);
      const blob = await response.blob();

      const reader = new FileReader();

      await new Promise((resolve) => {
        reader.onloadend = () => {

          // SIGN BORDER
          doc.setDrawColor(...GREEN);
          doc.setLineWidth(0.5);

          doc.rect(PW - 75, startY - 8, 55, 18);

          // SIGN IMAGE
          doc.addImage(
            reader.result,
            'PNG',
            PW - 74,
            startY - 7,
            53,
            16
          );

          resolve();
        };

        reader.readAsDataURL(blob);
      });
    }
  } catch (err) {
    console.log(err);
  }
};

    // ══════════════════════════════════════════════
    // BUILD THE PDF
    // ══════════════════════════════════════════════
    drawBorders();
    await drawHeader();
    drawFooter();

    let y = 60; // start below header ribbons

    const checkPageBreak = (requiredSpace = 30) => {
  if (y + requiredSpace > 260) {
    doc.addPage();

    // redraw page style
    drawBorders();
    drawFooter();

    // top heading for second page
    doc.setFillColor(...BLACK);
    doc.rect(11, 11, PW - 22, 10, 'F');

    doc.setTextColor(...WHITE);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);

    doc.text(
      'NEET 2027 APPLICATION DETAILS (CONTINUED)',
      PW / 2,
      18,
      { align: 'center' }
    );

    y = 30;
  }
};
    // Acknowledgement box
    y = drawAckBox(y);

    // ── SECTION 1: Personal Information ──
    checkPageBreak(60);
    y = drawSectionHeader('SECTION 1 — PERSONAL INFORMATION', y);
    const personalRows = [
      ['Applicant Name',       props.login?.user_details?.name || ''],
      ['Category',             props.assets?.cat_nam || ''],
      ["Father's Name",        props.assets?.fname || ''],
      ["Mother's Name",        props.assets?.Mname || ''],
      ['Gender',               props.assets?.gender || ''],
      ['Person w/ Disability', props.assets?.disabilities || ''],
      ['Date of Birth',        props.login?.user_details?.dob || ''],
      ['Aadhaar Number',       props.login?.user_details?.aadhar || ''],
      ['Mobile Number',        '+91' + (props.login?.user_details?.mobile || '')],
      ['WhatsApp Number',      props.assets?.wpno || ''],
    ];
    y = drawTable(personalRows, y, 55, 85);

    // ── SECTION 2: Address ──
    checkPageBreak(60);
    y = drawSectionHeader('SECTION 2 — ADDRESS DETAILS', y);
    const addressRows = [
      ['State',              props.assets?.state   || ''],
      ['District',           props.assets?.dist    || ''],
      ['Block/Municipality', props.assets?.block   || ''],
      ['Village/City',       props.assets?.village || ''],
      ['Pin Code',           props.assets?.pin     || ''],
    ];
    y = drawTable(addressRows, y, 55, 85);

    // ── SECTION 3: Academics ──
    checkPageBreak(60);
    y = drawSectionHeader('SECTION 3 — ACADEMIC INFORMATION', y);
    const halfW = (PW - 24) / 2;

    const rows10 = [
      ['School',     props.assets?.school            || ''],
      ['Board',      props.assets?.schoolboard        || ''],
      ['Year',       props.assets?.schoolpass         || ''],
      ['Full Marks', props.assets?.schoolfullmark     || ''],
      ['Secured',    props.assets?.schoolfullmarksec  || ''],
    ];
    const rows12 = [
      ['College',    props.assets?.clg               || ''],
      ['Board',      props.assets?.clgboard           || ''],
      ['Year',       props.assets?.clgpass            || ''],
      ['Full Marks', props.assets?.clgfullmark        || ''],
      ['Secured',    props.assets?.fullmarksecclg     || ''],
    ];

    const y10end = drawMiniSection('10th Standard', rows10, 11, y, halfW);
    const y12end = drawMiniSection('12th Standard', rows12, 11 + halfW + 2, y, halfW);
    y = Math.max(y10end, y12end);

    const neetRows = [
      ['Previous NEET Score',   props.assets?.neet       || '0'],
      ['NEET Attempts',         props.assets?.neetatm    || '0'],
      ['Preferred Exam Centre', props.assets?.examcenter || ''],
    ];
    y = drawTable(neetRows, y, 60, 80);
checkPageBreak(60);
    // ── SECTION 4: Documents ──
    y = drawSectionHeader('SECTION 4 — DOCUMENT SUBMISSION STATUS', y);
    y = drawDocTable(y);
checkPageBreak(50);
    // ── Declaration ──
    y = drawDeclaration(y);
checkPageBreak(40);
    // ── Signature strip ──
await drawSignatures(y);
    // ── Save ──
    doc.save(`${name}_NEET2027_Acknowledgement.pdf`);
  };
  // ══════════════════════════════════════════════════════════════
  // END PDF GENERATOR
  // ══════════════════════════════════════════════════════════════

  // ── Validators ────────────────────────────────────────────────
  const validateTab1 = () => {
    const e = {};
    if (!props.assets?.fname)        e.fname        = 'Father\'s name is required';
    if (!props.assets?.Mname)        e.Mname        = 'Mother\'s name is required';
    if (!props.assets?.cat_nam)      e.cat_nam      = 'Category is required';
    if (!props.assets?.gender)       e.gender       = 'Gender selection is required';
    if (!props.assets?.disabilities) e.disabilities = 'Please select Yes or No for disability';
    if (!props.assets?.wpno || !/^\d{10}$/.test(props.assets.wpno))
      e.wpno = 'Valid 10-digit WhatsApp number is required';
    return e;
  };
  const validateTab2 = () => {
    const e = {};
    if (!props.assets?.state)   e.state   = 'State is required';
    if (!props.assets?.dist)    e.dist    = 'District is required';
    if (!props.assets?.block)   e.block   = 'Block/Municipality is required';
    if (!props.assets?.village) e.village = 'Village/City is required';
    if (!props.assets?.pin)     e.pin     = 'Pin code is required';
    return e;
  };
  const validateTab3 = () => {
    const e = {};
    if (!props.assets?.school)            e.school            = 'School name & address is required';
    if (!props.assets?.schoolboard)       e.schoolboard       = '10th Board selection is required';
    if (!props.assets?.schoolpass)        e.schoolpass        = '10th Passing year is required';
    if (!props.assets?.schoolfullmark)    e.schoolfullmark    = '10th Full mark is required';
    if (!props.assets?.schoolfullmarksec) e.schoolfullmarksec = '10th Mark secured is required';
    if (!props.assets?.clg)              e.clg               = 'College name & address is required';
    if (!props.assets?.clgboard)         e.clgboard          = '12th Board selection is required';
    if (!props.assets?.clgpass)          e.clgpass           = '12th Passing year is required';
    if (!props.assets?.examcenter)       e.examcenter        = 'Exam centre selection is required';
    return e;
  };
  const validateDocs = () => {
    const e = { ...docErrors };
    if (!passportPhotoFile && !props.assets?.user_all_data?.profile_pic)
      e.passport  = e.passport  || 'Passport size photo is required';
    if (!aadharCardFile && !props.assets?.user_all_data?.aadharcertif)
      e.aadhar    = e.aadhar    || 'Aadhaar card document is required';
    if (!tenthMarksheetFile && !props.assets?.user_all_data?.tenthmarksheet)
      e.signature = e.signature || 'Signature document is required';
    return e;
  };

  const userName = props.login?.user_details?.name || '';
  const userPic  = props.login?.user_details?.profile_pic || '';

  return (
    <div className="p27-page">

      {/* ── TOP HEADER ── */}
      <div className="p27-topbar">
        <div className="p27-topbar-inner">
          <div className="p27-topbar-brand">
            <img
              className="p27-topbar-logo-img"
              src={Logo}
              alt="Prayash Logo"
              onError={e => { e.target.style.display = 'none'; }}
            />
            <div>
              <span className="p27-topbar-title">PRAYASH EDUCATION</span>
              <span className="p27-topbar-sub">NEET 2027 — Candidate Portal</span>
            </div>
          </div>
          <div className="p27-topbar-user">
            <div className="p27-user-avatar">
              {userPic
                ? <img src={userPic} alt="avatar" />
                : <span>{(userName || 'U')[0].toUpperCase()}</span>
              }
            </div>
            <span className="p27-user-name">{userName}</span>
          </div>
        </div>
      </div>

      {/* ── LAYOUT ── */}
      <div className="p27-layout">

        {/* ── SIDEBAR ── */}
        <aside className="p27-sidebar">
          <div className="p27-sidebar-inner">
            <div className="p27-sidebar-heading">Form Progress</div>
            {STEPS.map((step) => (
              <button
                key={step.id}
                className={`p27-step-btn ${value === step.id ? 'active' : ''} ${value > step.id ? 'done' : ''}`}
                onClick={() => { if (step.id < value) { setValue(step.id); setErrors({}); } }}
              >
                <span className="p27-step-icon">{value > step.id ? '✓' : step.icon}</span>
                <div>
                  <span className="p27-step-label">{step.label}</span>
                  <span className="p27-step-num">Step {step.id + 1}</span>
                </div>
              </button>
            ))}
            <div className="p27-progress-bar">
              <div className="p27-progress-fill" style={{ width: `${(value / 4) * 100}%` }}></div>
            </div>
            <div className="p27-progress-text">{value}/4 steps completed</div>
          </div>
        </aside>

        {/* ── MAIN CONTENT ── */}
        <main className="p27-main">

          {/* ══ TAB 0: STUDENT PROFILE ══ */}
          {value === 0 && (
            <div className="p27-panel">
              <div className="p27-panel-header">
                <div className="p27-panel-icon">👤</div>
                <div>
                  <h2>Student Profile Information</h2>
                  <p>Basic personal details of the candidate</p>
                </div>
              </div>

              <ErrorBanner errors={errors} />

              <div className="p27-section">
                <div className="p27-section-title">Basic Information</div>
                <div className="p27-grid-2">
                  <Field label="Applicant Name">
                    <input className="p27-input p27-input--disabled" type="text" value={props.login?.user_details?.name || ''} disabled />
                  </Field>

                  <Field label="Category" required error={errors.cat_nam}>
                    <select
                      className={`p27-select ${errors.cat_nam ? 'p27-select--error' : ''}`}
                      value={props.assets?.cat_nam || ''}
                      onChange={(e) => { props.SetprofileCat(e.target.value); setErrors(p => ({ ...p, cat_nam: '' })); }}>
                      <option value="">Select Category</option>
                      {['General','OBC','GEN-EWS','SC','ST'].map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </Field>

                  <Field label="Father's Name" required error={errors.fname}>
                    <input className={`p27-input ${errors.fname ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Enter father's full name"
                      value={props.assets?.fname || ''}
                      onChange={(e) => { props.setFname(e.target.value); setErrors(p => ({ ...p, fname: '' })); }} />
                  </Field>

                  <Field label="Mother's Name" required error={errors.Mname}>
                    <input className={`p27-input ${errors.Mname ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Enter mother's full name"
                      value={props.assets?.Mname || ''}
                      onChange={(e) => { props.setMname(e.target.value); setErrors(p => ({ ...p, Mname: '' })); }} />
                  </Field>
                </div>
              </div>

              <div className="p27-section">
                <div className="p27-section-title">Identity & Contact</div>
                <div className="p27-grid-2">
                  <Field label="Date of Birth">
                    <input className="p27-input p27-input--disabled" type="date" value={props.login?.user_details?.dob || ''} disabled />
                  </Field>
                  <Field label="Aadhaar Number">
                    <input className="p27-input p27-input--disabled" type="text" value={props.login?.user_details?.aadhar || ''} disabled maxLength={12} />
                  </Field>
                  <Field label="Mobile Number">
                    <div className="p27-input-prefix-wrap">
                      <span className="p27-prefix">+91</span>
                      <input className="p27-input p27-input--disabled p27-input--prefixed" type="text" value={props.login?.user_details?.mobile || ''} disabled />
                    </div>
                  </Field>
                  <Field label="WhatsApp Number" required error={errors.wpno}>
                    <div className="p27-input-prefix-wrap">
                      <span className="p27-prefix">+91</span>
                      <input className={`p27-input p27-input--prefixed ${errors.wpno ? 'p27-input--error' : ''}`}
                        type="text" placeholder="10-digit WhatsApp number"
                        value={props.assets?.wpno || ''}
                        maxLength={10}
                        onChange={(e) => { if (/^\d{0,10}$/.test(e.target.value)) { props.setWp(e.target.value); setErrors(p => ({ ...p, wpno: '' })); } }} />
                    </div>
                  </Field>
                </div>
              </div>

              <div className="p27-section">
                <div className="p27-section-title">Additional Details</div>
                <div className="p27-grid-2">
                  <Field label="Gender" required error={errors.gender}>
                    <div className="p27-radio-group">
                      {['female','male','other'].map(g => (
                        <label key={g} className={`p27-radio-label ${props.assets?.gender === g ? 'p27-radio-label--active' : ''}`}>
                          <input type="radio" name="gender" value={g}
                            checked={props.assets?.gender === g}
                            onChange={(e) => { props.setGender(e.target.value); setErrors(p => ({ ...p, gender: '' })); }} />
                          {g.charAt(0).toUpperCase() + g.slice(1)}
                        </label>
                      ))}
                    </div>
                    {errors.gender && <span className="p27-err-msg">{errors.gender}</span>}
                  </Field>

                  <Field label="Person with Disability" required error={errors.disabilities}>
                    <div className="p27-radio-group">
                      {['yes','no'].map(d => (
                        <label key={d} className={`p27-radio-label ${props.assets?.disabilities === d ? 'p27-radio-label--active' : ''}`}>
                          <input type="radio" name="disabilities" value={d}
                            checked={props.assets?.disabilities === d}
                            onChange={(e) => { props.serDisabilities(e.target.value); setErrors(p => ({ ...p, disabilities: '' })); }} />
                          {d.charAt(0).toUpperCase() + d.slice(1)}
                        </label>
                      ))}
                    </div>
                    {errors.disabilities && <span className="p27-err-msg">{errors.disabilities}</span>}
                  </Field>
                </div>
              </div>

              <div className="p27-actions">
                <button className="p27-btn p27-btn--primary" onClick={() => {
                  const e = validateTab1();
                  if (Object.keys(e).length > 0) { setErrors(e); return; }
                  setErrors({});
                  setValue(1);
                }}>Next: Address →</button>
              </div>
            </div>
          )}

          {/* ══ TAB 1: ADDRESS ══ */}
          {value === 1 && (
            <div className="p27-panel">
              <div className="p27-panel-header">
                <div className="p27-panel-icon">📍</div>
                <div>
                  <h2>Address Information</h2>
                  <p>Current residential address of the candidate</p>
                </div>
              </div>

              <ErrorBanner errors={errors} />

              <div className="p27-section">
                <div className="p27-section-title">State & District</div>
                <div className="p27-grid-2">
                  <Field label="State" required error={errors.state}>
                    <select className={`p27-select ${errors.state ? 'p27-select--error' : ''}`}
                      value={props.assets?.state || ''}
                      onChange={(e) => { props.setSaste(e.target.value); setErrors(p => ({ ...p, state: '', dist: '' })); }}>
                      <option value="">Select State</option>
                      {Object.keys(districtsData).map(s => <option key={s} value={s}>{s}</option>)}
                      <option value="Others">Others</option>
                    </select>
                  </Field>

                  <Field label="District" required error={errors.dist}>
                    <select className={`p27-select ${errors.dist ? 'p27-select--error' : ''}`}
                      value={props.assets?.dist || ''}
                      onChange={(e) => { props.setDist(e.target.value); setErrors(p => ({ ...p, dist: '' })); }}>
                      <option value="">Select District</option>
                      {getDistricts(props.assets?.state).map(d => <option key={d} value={d}>{d}</option>)}
                      <option value="Others">Others</option>
                    </select>
                  </Field>
                </div>
              </div>

              <div className="p27-section">
                <div className="p27-section-title">Local Address</div>
                <div className="p27-grid-2">
                  <Field label="Block / Municipality" required error={errors.block}>
                    <input className={`p27-input ${errors.block ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Block or municipality name"
                      value={props.assets?.block || ''}
                      onChange={(e) => { props.setBlock(e.target.value); setErrors(p => ({ ...p, block: '' })); }} />
                  </Field>

                  <Field label="Village / City Name" required error={errors.village}>
                    <input className={`p27-input ${errors.village ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Village or city name"
                      value={props.assets?.village || ''}
                      onChange={(e) => { props.setvillage(e.target.value); setErrors(p => ({ ...p, village: '' })); }} />
                  </Field>

                  <Field label="Pin Code" required error={errors.pin}>
                    <input className={`p27-input ${errors.pin ? 'p27-input--error' : ''}`} type="text"
                      placeholder="6-digit pin code"
                      value={props.assets?.pin || ''}
                      maxLength={6}
                      onChange={(e) => { if (/^\d{0,6}$/.test(e.target.value)) { props.setPin(e.target.value); setErrors(p => ({ ...p, pin: '' })); } }} />
                  </Field>
                </div>
              </div>

              <div className="p27-actions">
                <button className="p27-btn p27-btn--ghost" onClick={handleBack}>← Back</button>
                <button className="p27-btn p27-btn--primary" onClick={() => {
                  const e = validateTab2();
                  if (Object.keys(e).length > 0) { setErrors(e); return; }
                  setErrors({});
                  setValue(2);
                }}>Next: Academics →</button>
              </div>
            </div>
          )}

          {/* ══ TAB 2: ACADEMICS ══ */}
          {value === 2 && (
            <div className="p27-panel">
              <div className="p27-panel-header">
                <div className="p27-panel-icon">🎓</div>
                <div>
                  <h2>Academic Information</h2>
                  <p>10th, 12th and NEET 2027 examination details</p>
                </div>
              </div>

              <ErrorBanner errors={errors} />

              {/* 10th */}
              <div className="p27-section">
                <div className="p27-section-badge">10th Standard Details</div>
                <div className="p27-grid-2">
                  <Field label="School Name & Address" required error={errors.school}>
                    <input className={`p27-input ${errors.school ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Full name and address of school"
                      value={props.assets?.school || ''}
                      onChange={(e) => { props.setTenScl(e.target.value); setErrors(p => ({ ...p, school: '' })); }} />
                  </Field>

                  <Field label="Board" required error={errors.schoolboard}>
                    <select className={`p27-select ${errors.schoolboard ? 'p27-select--error' : ''}`}
                      value={props.assets?.schoolboard || ''}
                      onChange={(e) => { props.setTenSclBord(e.target.value); setErrors(p => ({ ...p, schoolboard: '' })); }}>
                      <option value="">Select Board</option>
                      {['BSE, Odisha','CBSE, New Delhi','ICSE','Other'].map(b => <option key={b} value={b}>{b}</option>)}
                    </select>
                  </Field>

                  <Field label="Year of Passing" required error={errors.schoolpass}>
                    <select className={`p27-select ${errors.schoolpass ? 'p27-select--error' : ''}`}
                      value={props.assets?.schoolpass || ''}
                      onChange={(e) => { props.setTenSclpass(e.target.value); setErrors(p => ({ ...p, schoolpass: '' })); }}>
                      <option value="">Select Year</option>
                      {years.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </Field>

                  <Field label="Full Mark" required error={errors.schoolfullmark}>
                    <input className={`p27-input ${errors.schoolfullmark ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Total marks"
                      value={props.assets?.schoolfullmark || ''}
                      onChange={(e) => { props.setTenSclfullmark(e.target.value.replace(/\D/g,'').slice(0,4)); setErrors(p => ({ ...p, schoolfullmark: '' })); }} />
                  </Field>

                  <Field label="Mark Secured" required error={errors.schoolfullmarksec}>
                    <input className={`p27-input ${errors.schoolfullmarksec ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Marks obtained"
                      value={props.assets?.schoolfullmarksec || ''}
                      onChange={(e) => { props.setTenSclfullmarksec(e.target.value.replace(/\D/g,'').slice(0,4)); setErrors(p => ({ ...p, schoolfullmarksec: '' })); }} />
                  </Field>
                </div>
              </div>

              {/* 12th */}
              <div className="p27-section">
                <div className="p27-section-badge p27-section-badge--blue">12th Standard Details</div>
                <div className="p27-grid-2">
                  <Field label="College Name & Address" required error={errors.clg}>
                    <input className={`p27-input ${errors.clg ? 'p27-input--error' : ''}`} type="text"
                      placeholder="Full name and address of college"
                      value={props.assets?.clg || ''}
                      onChange={(e) => { props.setTowClg(e.target.value); setErrors(p => ({ ...p, clg: '' })); }} />
                  </Field>

                  <Field label="Board" required error={errors.clgboard}>
                    <select className={`p27-select ${errors.clgboard ? 'p27-select--error' : ''}`}
                      value={props.assets?.clgboard || ''}
                      onChange={(e) => { props.setTowClgBord(e.target.value); setErrors(p => ({ ...p, clgboard: '' })); }}>
                      <option value="">Select Board</option>
                      {['CHSE, Odisha','CBSE, New Delhi','ICSE','Other'].map(b => <option key={b} value={b}>{b}</option>)}
                    </select>
                  </Field>

                  <Field label="Year of Passing" required error={errors.clgpass}>
                    <select className={`p27-select ${errors.clgpass ? 'p27-select--error' : ''}`}
                      value={props.assets?.clgpass || ''}
                      onChange={(e) => { props.setTowClgpass(e.target.value); setErrors(p => ({ ...p, clgpass: '' })); }}>
                      <option value="">Select Year</option>
                      {yeartwo.map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </Field>

                  {/* Hide marks fields for 2026 & 2027 (results not yet out) */}
                  {!['2026', '2027'].includes(props.assets?.clgpass) && (
                    <>
                      <Field label="Full Mark">
                        <input className="p27-input" type="text" placeholder="Total marks"
                          value={props.assets?.clgfullmark || ''}
                          onChange={(e) => props.setTowClgfullmark(e.target.value.replace(/\D/g,'').slice(0,4))} />
                      </Field>
                      <Field label="Mark Secured">
                        <input className="p27-input" type="text" placeholder="Marks obtained"
                          value={props.assets?.fullmarksecclg || ''}
                          onChange={(e) => props.setTowClgfullmarksec(e.target.value.replace(/\D/g,'').slice(0,4))} />
                      </Field>
                    </>
                  )}
                </div>
              </div>

              {/* NEET */}
              <div className="p27-section">
                <div className="p27-section-badge p27-section-badge--orange">NEET 2027 Details</div>
                <div className="p27-grid-2">
                  <Field label="Previous NEET Score (if any)">
                    <input className="p27-input" type="text" placeholder="Enter score or 0"
                      value={props.assets?.neet || ''}
                      onChange={(e) => props.setNeet(e.target.value.replace(/\D/g,'').slice(0,4))} />
                  </Field>
                  <Field label="Number of NEET Attempts">
                    <select className="p27-select"
                      value={props.assets?.neetatm || '0'}
                      onChange={(e) => props.setNeetatm(e.target.value)}>
                      {Array.from({ length: 11 }, (_, i) => <option key={i} value={String(i)}>{i}</option>)}
                    </select>
                  </Field>
                </div>
              </div>

              {/* Exam Center */}
              <div className="p27-section">
                <div className="p27-section-title">Exam Centre Preference</div>
                <div className="p27-exam-centers">
                  {['Jajpur','Bhubaneswar','Angul','Balasore'].map(city => (
                    <label key={city} className={`p27-center-card ${props.assets?.examcenter === city ? 'p27-center-card--active' : ''}`}>
                      <input type="radio" name="examcenter" value={city}
                        checked={props.assets?.examcenter === city}
                        onChange={(e) => { props.setCitycenter(e.target.value); setErrors(p => ({ ...p, examcenter: '' })); }} />
                      <span className="p27-center-icon">📍</span>
                      <span>{city}</span>
                    </label>
                  ))}
                </div>
                {errors.examcenter && <span className="p27-err-msg" style={{marginTop:'8px',display:'block'}}>{errors.examcenter}</span>}
              </div>

              <div className="p27-actions">
                <button className="p27-btn p27-btn--ghost" onClick={handleBack}>← Back</button>
                <button className="p27-btn p27-btn--primary" onClick={() => {
                  const e = validateTab3();
                  if (Object.keys(e).length > 0) { setErrors(e); return; }
                  setErrors({});
                  setValue(3);
                }}>Next: Documents →</button>
              </div>
            </div>
          )}

          {/* ══ TAB 3: DOCUMENTS ══ */}
          {value === 3 && (
            <div className="p27-panel">
              <div className="p27-panel-header">
                <div className="p27-panel-icon">📄</div>
                <div>
                  <h2>Document Upload</h2>
                  <p>Upload documents in JPG or PNG format • Size: <strong>100 KB – 250 KB</strong></p>
                </div>
              </div>

              <ErrorBanner errors={docErrors} />

              <div className="p27-section">
                <div className="p27-section-title">Required Documents</div>

                <div className="p27-doc-size-rule">
                  <span>📐</span>
                  <span>Each image must be between <strong>100 KB</strong> and <strong>250 KB</strong>.
                  Files outside this range will be rejected automatically.</span>
                </div>

                <div className="p27-doc-grid">
                  {[
                    {
                      key: 'aadhar',
                      icon: '🪪', name: 'Aadhaar Card',
                      hint: 'JPG, PNG or PDF • 100 KB – 250 KB',
                      accept: 'image/*,application/pdf',
                      onChange: handleAadharCardChange,
                      file: aadharCardFile,
                      prev: props.assets?.user_all_data?.aadharcertif,
                    },
                    {
                      key: 'signature',
                      icon: '✍️', name: 'Signature',
                      hint: 'JPG or PNG • 100 KB – 250 KB • White background',
                      accept: 'image/*',
                      onChange: handleTenthMarksheetChange,
                      file: tenthMarksheetFile,
                      prev: props.assets?.user_all_data?.tenthmarksheet,
                    },
                    {
                      key: 'passport',
                      icon: '📷', name: 'Passport Size Photo',
                      hint: 'JPG or PNG • 100 KB – 250 KB • White background',
                      accept: 'image/*',
                      onChange: handlePassportPhotoChange,
                      file: passportPhotoFile,
                      prev: props.assets?.user_all_data?.profile_pic,
                    },
                  ].map((doc) => (
                    <div key={doc.name} className={`p27-doc-card ${docErrors[doc.key] ? 'p27-doc-card--error' : ''}`}>
                      <div className="p27-doc-icon">{doc.icon}</div>
                      <div className="p27-doc-info">
                        <div className="p27-doc-name">{doc.name} <span className="p27-req">*</span></div>
                        <div className="p27-doc-hint">{doc.hint}</div>
                        {doc.file && (
                          <span className="p27-file-name">
                            ✓ {doc.file.name} ({(doc.file.size / 1024).toFixed(0)} KB)
                          </span>
                        )}
                        {docErrors[doc.key] && (
                          <span className="p27-doc-err">⚠ {docErrors[doc.key]}</span>
                        )}
                      </div>
                      <label className={`p27-upload-btn
                        ${doc.file || doc.prev ? 'p27-upload-btn--done' : ''}
                        ${docErrors[doc.key] ? 'p27-upload-btn--err' : ''}`}>
                        {docErrors[doc.key] ? '✕ Re-upload' : doc.file ? '✓ Changed' : doc.prev ? '✓ Uploaded' : '+ Upload'}
                        <input type="file" accept={doc.accept} onChange={doc.onChange} style={{ display: 'none' }} />
                      </label>
                    </div>
                  ))}
                </div>

                <div className="p27-doc-note">
                  <span>ℹ️</span>
                  <span>All documents must be clearly readable. Blurry or incomplete uploads will be rejected.</span>
                </div>
              </div>

              <div className="p27-actions">
                <button className="p27-btn p27-btn--ghost" onClick={handleBack}>← Back</button>
                <button className="p27-btn p27-btn--success" onClick={() => {
                  const de = validateDocs();
                  const hasErrors = Object.values(de).some(Boolean);
                  if (hasErrors) { setDocErrors(de); return; }
                  SetPreview(true);
                }}>Preview & Submit ✓</button>
              </div>
            </div>
          )}

        </main>
      </div>

      {/* ══ PREVIEW DIALOG ══ */}
      <Dialog open={preview} fullScreen PaperProps={{ style: { background: '#f4f6f8' } }}>
        <div className="p27-preview-header">
          <div className="p27-preview-title">
            <span>📋</span>
            <div>
              <strong>Application Preview</strong>
              <span>Review all details before final submission</span>
            </div>
          </div>
          <button className="p27-preview-close" onClick={() => SetPreview(false)}>✕</button>
        </div>

        <DialogContent sx={{ padding: '24px', maxWidth: '860px', margin: '0 auto', width: '100%' }}>
          <div className="p27-preview-body">

            <div className="p27-preview-section">
              <div className="p27-preview-section-title">👤 Basic Information</div>
              <div className="p27-preview-grid">
                {[
                  ['Applicant Name', props.login?.user_details?.name],
                  ['Category', props.assets?.cat_nam],
                  ["Father's Name", props.assets?.fname],
                  ["Mother's Name", props.assets?.Mname],
                  ['Gender', props.assets?.gender],
                  ['Disabilities', props.assets?.disabilities],
                  ['Date of Birth', props.login?.user_details?.dob],
                  ['Aadhaar Number', props.login?.user_details?.aadhar],
                  ['Mobile No', `+91${props.login?.user_details?.mobile || ''}`],
                  ['WhatsApp No', props.assets?.wpno],
                ].map(([k, v]) => (
                  <div key={k} className="p27-preview-field">
                    <span className="p27-preview-key">{k}</span>
                    <span className="p27-preview-val">{v || '—'}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="p27-preview-section">
              <div className="p27-preview-section-title">📍 Address Details</div>
              <div className="p27-preview-grid">
                {[
                  ['State', props.assets?.state], ['District', props.assets?.dist],
                  ['Block/Municipality', props.assets?.block], ['Village/City', props.assets?.village],
                  ['Pin Code', props.assets?.pin],
                ].map(([k, v]) => (
                  <div key={k} className="p27-preview-field">
                    <span className="p27-preview-key">{k}</span>
                    <span className="p27-preview-val">{v || '—'}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="p27-preview-section">
              <div className="p27-preview-section-title">🎓 Academic Details</div>
              <div className="p27-preview-grid">
                {[
                  ['School Name', props.assets?.school], ['10th Board', props.assets?.schoolboard],
                  ['10th Year', props.assets?.schoolpass], ['10th Full Mark', props.assets?.schoolfullmark],
                  ['10th Mark Secured', props.assets?.schoolfullmarksec],
                  ['College Name', props.assets?.clg], ['12th Board', props.assets?.clgboard],
                  ['12th Year', props.assets?.clgpass], ['12th Full Mark', props.assets?.clgfullmark],
                  ['12th Mark Secured', props.assets?.fullmarksecclg],
                  ['NEET Score', props.assets?.neet], ['NEET Attempts', props.assets?.neetatm],
                  ['Exam Centre', props.assets?.examcenter],
                ].map(([k, v]) => (
                  <div key={k} className="p27-preview-field">
                    <span className="p27-preview-key">{k}</span>
                    <span className="p27-preview-val">{v || '—'}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="p27-preview-section">
              <div className="p27-preview-section-title">📄 Document Verification</div>
              <div className="p27-check-list">
                {[
                  ['Passport Size Photo Uploaded', passportChecked, setPassportChecked],
                  ['Signature Uploaded', tenthMarksheetChecked, setTenthMarksheetChecked],
                  ['Aadhaar Card Uploaded', disabilitiesChecked, setDisabilitiesChecked],
                ].map(([label, checked, setter]) => (
                  <label key={label} className={`p27-check-item ${checked ? 'p27-check-item--checked' : ''}`}>
                    <input type="checkbox" checked={checked} onChange={e => setter(e.target.checked)} />
                    <span>{label}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="p27-confirm-box">
              <label className={`p27-check-item p27-check-item--confirm ${confirmed ? 'p27-check-item--checked' : ''}`}>
                <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} />
                <span>I confirm that all the information provided is <strong>true and accurate</strong> to the best of my knowledge.</span>
              </label>
              {!confirmed && <div className="p27-confirm-warn">⚠ Please check the confirmation box to proceed with final submission.</div>}
            </div>

          </div>
        </DialogContent>

        <DialogActions sx={{ padding: '16px 24px', background: '#fff', borderTop: '1px solid #e0e0e0', justifyContent: 'space-between' }}>
          <button className="p27-btn p27-btn--ghost" onClick={() => SetPreview(false)}>← Edit Form</button>
          <button
            className={`p27-btn p27-btn--success ${!confirmed ? 'p27-btn--disabled' : ''}`}
            disabled={!confirmed}
            onClick={() => {
              if (!confirmed) return;
              SetPreview(false);
              handleSubmit();
            }}>
            Final Submit ✓
          </button>
        </DialogActions>
      </Dialog>

      {/* ══ SUCCESS DIALOG ══ */}
    {/* ══ SUCCESS DIALOG ══ */}
<Dialog open={openDialog} onClose={() => {}}
  PaperProps={{ style: { borderRadius: '16px', padding: '8px', minWidth: '380px', maxWidth: '440px' } }}>
  <div className="p27-success-dialog" style={{ textAlign: 'center', padding: '8px 16px 0' }}>

    {/* Mission Badge */}
    <div style={{
      background: '#000', borderRadius: '10px', padding: '12px 20px',
      marginBottom: '16px', border: '2px solid #9dde59'
    }}>
      <div style={{ color: '#9dde59', fontWeight: 900, fontSize: '15px', letterSpacing: '1.5px' }}>
        PRAYASH MISSION NEET 2027
      </div>
      <div style={{ color: '#ccc', fontSize: '11px', marginTop: '3px' }}>
        Empowering Students. Transforming Futures.
      </div>
    </div>

    {/* Photo preview */}
    {(props.assets?.user_all_data?.profile_pic || passportPhotoFile) && (
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '14px' }}>
        <img
          src={
            props.assets?.user_all_data?.profile_pic
              ? props.assets.user_all_data.profile_pic
              : URL.createObjectURL(passportPhotoFile)
          }
          alt="Candidate"
          style={{
            width: '80px', height: '90px', objectFit: 'cover',
            border: '3px solid #9dde59', borderRadius: '6px'
          }}
        />
      </div>
    )}

    <div className="p27-success-icon" style={{ fontSize: '40px', marginBottom: '8px' }}>🎉</div>
    <h3 style={{ margin: '0 0 6px', color: '#1a3a6b' }}>Submission Successful!</h3>
    <p style={{ color: '#444', fontSize: '13px', lineHeight: 1.6, marginBottom: '16px' }}>
      Your application has been submitted to<br />
      <strong>Prayash Mission NEET 2027</strong>.<br />
      Download your acknowledgement for records.
    </p>

    <button
      className="p27-btn p27-btn--primary p27-btn--full"
      onClick={generatePDF2}
      style={{ background: '#9dde59', color: '#000', fontWeight: 700, border: 'none', padding: '12px', borderRadius: '8px', width: '100%', cursor: 'pointer', fontSize: '14px', marginBottom: '8px' }}
    >
      ⬇ Download Acknowledgement PDF
    </button>
  </div>

  <DialogActions sx={{ justifyContent: 'center', paddingBottom: '16px' }}>
    <button
      className="p27-btn p27-btn--ghost"
      onClick={() => setOpenDialog(false)}
      style={{ background: 'transparent', border: '1px solid #ccc', padding: '8px 24px', borderRadius: '8px', cursor: 'pointer', color: '#555' }}
    >
      Close
    </button>
  </DialogActions>
</Dialog>

      <Snackbar open={props.snackbar?.response_received} close_snack_bar={props.close_snack_bar} message={props.snackbar?.message} />
      <Loader />
    </div>
  );
}